import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  initialize() {
    this.anchor = location.hash;

    if (this.anchor) {
      this.openAnchor();
      this.smoothScroll();
    }
  }

  openScroll(e) {
    e.preventDefault();

    this.anchor = $(e.currentTarget).attr("href");

    if (this.anchor) {
      this.openAnchor();
      this.smoothScroll();
    }
  }

  openAnchor() {
    var toggle = $(this.anchor),
      content = toggle.parents(".js-toggle");
    if (content) {
      var content_panel = content.children(".js-toggle-panel");

      content.addClass("is-open");
      content_panel.slideDown();
      // aria属性
      content.children(".js-toggle-trigger").attr("aria-expanded", true);
      content_panel.attr("aria-hidden", false);
    }

    var panel = toggle.children(".js-toggle-panel");
    toggle.addClass("is-open");
    panel.slideDown();
    // aria属性
    toggle.children(".js-toggle-trigger").attr("aria-expanded", true);
    panel.attr("aria-hidden", false);
  }

  smoothScroll() {
    $.easing.quart = function (x, t, b, c, d) {
      return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    };

    var speed = 1200,
      toggle = $(this.anchor),
      position = toggle.offset().top,
      y_position = window.scrollY;

    if (position == y_position) {
      return false;
    } else {
      $("html, body").animate(
        {
          scrollTop: position,
        },
        speed,
        "quart",
      );
    }
  }
}
